import { replaceVar } from '@/app/components/search/utils/misc';

const ONE_MINUTE_IN_MS = 1000 * 60;
const ONE_DAY_IN_MS = ONE_MINUTE_IN_MS * 60 * 24;

export const dateWithoutTime = (fullDate: string): Date => new Date(`${fullDate.split('T')[0]}T00:00:00.000`);

export const calcDeltaDays = (firstDate: string, secondDate: string): number => {
  const differenceInMs = dateWithoutTime(secondDate).getTime() - dateWithoutTime(firstDate).getTime();
  const differenceInDays = Math.trunc(differenceInMs / ONE_DAY_IN_MS);

  return differenceInDays < 0 ? differenceInDays * -1 : differenceInDays;
};

export const decorateAge = (durationInMinutes: number, dictionary: Dictionary): string => {
  const minutes = (durationInMinutes % 60).toString().padStart(2, '0');
  const hours = Math.trunc(durationInMinutes / 60);

  if (hours === 0) {
    return replaceVar(dictionary['widget.trip_card.duration.in.minutes'].replace(/__(.*?)__/g, '{$1}'), {
      minutes,
    });
  }

  return replaceVar(dictionary['widget.trip_card.duration.in.hours'].replace(/__(.*?)__/g, '{$1}'), {
    hours: hours.toString(),
    minutes,
  });
};

export const WayStops = ({ numberOfStops, dictionary }: { numberOfStops: number; dictionary: Dictionary }): string => {
  const stopsKeys: { [key: string]: string } = {
    '0': 'widget.trip_card.stops.direct',
    '1': 'widget.trip_card.stops.flight.one',
  };

  return replaceVar(
    dictionary[stopsKeys[`${numberOfStops}`]] ||
      dictionary['widget.trip_card.stops.flight.several'].replace(/__(.*?)__/g, '{$1}'),
    { stops: numberOfStops.toString() }
  );
};
